<template>
    <div>
        <div class="row" v-if="method===null">
            <div class="col-lg-4">
                <button class="btn btn-lg btn-primary btn-block mt-2 mt-lg-0 p-4" @click="setMethod('token')">
                    <font-awesome-icon icon="key" size="2x"/>
                    <div>{{$t('contacts.addModal.addTypes.token')}}</div>
                </button>
            </div>
            <div class="col-lg-4">
                <button class="btn btn-lg btn-primary btn-block mt-2 mt-lg-0 p-4" @click="setMethod('scan')">
                    <font-awesome-icon icon="qrcode" size="2x"/>
                    <div>{{$t('contacts.addModal.addTypes.scan')}}</div>
                </button>
            </div>
            <div class="col-lg-4">
                <button class="btn btn-lg btn-primary btn-block mt-2 mt-lg-0 p-4" @click="setMethod('email')">
                    <font-awesome-icon icon="envelope" size="2x"/>
                    <div>{{$t('contacts.addModal.addTypes.email')}}</div>
                </button>
            </div>
        </div>
        <pair-scan v-if="method==='scan'"/>
        <pair-token v-if="method==='token'"/>
        <pair-email v-if="method==='email'"/>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import PairScan from './PairScan';
import PairToken from './PairToken';
import PairEmail from './PairEmail';

export default {
    components: {PairEmail, PairToken, PairScan},
    computed: mapGetters({
        method: 'contact/pair/method',
    }),
    methods: {
        ...mapActions({
            setMethod: 'contact/pair/setMethod',
            getToken: 'contact/pair/getToken',
        }),
    },
    created() {
        this.$store.dispatch('contact/pair/reset');
        this.getToken(true);
    },
}
</script>



// WEBPACK FOOTER //
// src/components/contact/PairMethodSelection.vue